var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCirclePurpleLighter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 6.9987C0.333008 3.3187 3.31967 0.332031 6.99967 0.332031C10.6797 0.332031 13.6663 3.3187 13.6663 6.9987C13.6663 10.6787 10.6797 13.6654 6.99967 13.6654C3.31967 13.6654 0.333008 10.6787 0.333008 6.9987ZM2.79969 7.46537L5.19302 9.8587C5.45302 10.1187 5.87969 10.1187 6.13302 9.8587L11.193 4.7987C11.453 4.5387 11.453 4.1187 11.193 3.8587C10.933 3.5987 10.513 3.5987 10.253 3.8587L5.66636 8.44537L3.73969 6.52537C3.47969 6.26537 3.05969 6.26537 2.79969 6.52537C2.67485 6.64992 2.6047 6.81902 2.6047 6.99537C2.6047 7.17171 2.67485 7.34081 2.79969 7.46537Z",
    fill: "#C3C7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 6.9987C0.333008 3.3187 3.31967 0.332031 6.99967 0.332031C10.6797 0.332031 13.6663 3.3187 13.6663 6.9987C13.6663 10.6787 10.6797 13.6654 6.99967 13.6654C3.31967 13.6654 0.333008 10.6787 0.333008 6.9987ZM2.79969 7.46537L5.19302 9.8587C5.45302 10.1187 5.87969 10.1187 6.13302 9.8587L11.193 4.7987C11.453 4.5387 11.453 4.1187 11.193 3.8587C10.933 3.5987 10.513 3.5987 10.253 3.8587L5.66636 8.44537L3.73969 6.52537C3.47969 6.26537 3.05969 6.26537 2.79969 6.52537C2.67485 6.64992 2.6047 6.81902 2.6047 6.99537C2.6047 7.17171 2.67485 7.34081 2.79969 7.46537Z",
    fill: "#2E5BFF",
    fillOpacity: 0.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePurpleLighter);
export default __webpack_public_path__ + "static/media/check-circle-purple-lighter.632cc406a7717ad53ab1c35c0132f5c2.svg";
export { ForwardRef as ReactComponent };